import styled from 'styled-components';
// old design
export const PageWrapper = styled.div `
  margin: 73px auto 0;
  width: 622px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
// new design
export const PageWrapperNew = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
